<activities-block
  *ngIf="!!(course$ | async)"
  entityType="course"
  [entityId]="(course$ | async)?.id"
  [joins]="[{ field: 'member' }, { field: 'user' }, { field: 'product' }]"
  [initialLimit]="25"
  showParent="false"
  wcagLabel="wcag.logsMenu"
></activities-block>
